import { toast } from "react-toastify";

// 공통 기본 옵션
const defaultOptions = {
    position: "top-right",
    autoClose: 3000,
    pauseOnHover: true,
    closeOnClick: true,
    draggable: true,
    theme:"dark"
};

// 공통 함수
export const showToast = {
    success: (msg, options = {}) =>
        toast.success(msg, { ...defaultOptions, ...options }),

    error: (msg, options = {}) =>
        toast.error(msg, { ...defaultOptions, ...options }),

    info: (msg, options = {}) =>
        toast.info(msg, { ...defaultOptions, ...options }),

    warning: (msg, options = {}) =>
        toast.warning(msg, { ...defaultOptions, ...options }),
};